// MODULES
import React from "react";

export default class Collection extends React.PureComponent {

	adminCostString = "En fast administrationsavgift om 19kr/mån tas ut per kvartal per depå, dock max 29kr/mån och kund.";

	render() {
		const {props} = this;
		const {session} = props;

		/**
		 * There is no account type choice for AuAg.
		 * Non-companies always get an ISK - companies always get a standard account.
		 */
		const accountTypeIskChecked = !session.isCompany;
		const accountTypeNakedChecked = session.isCompany;

		return (
			<React.Fragment>
				<input type="hidden" name="checkbox_account_isk" value={accountTypeIskChecked ? "yes" : "no"}/>
				<input type="hidden" name="checkbox_account_naked" value={accountTypeNakedChecked ? "yes" : "no"}/>
				<input type="hidden" name="radio_account_type_open" value="Brutto"/>
				<input type="hidden" name="advice_portfolio_admincost" value={this.adminCostString}/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/auagfonder/Fields/collections/CollectionAccountType.js